import { hot } from 'react-hot-loader/root';
import Component from './terms-view';

export default hot(Component);
